import React from 'react'
import { Link } from 'react-router-dom'
import HeaderSix from '../components/header/HeaderSix'
import FooterSix from '../components/footer/FooterSix'
import ScrollAnimation from '../components/motion/ScrollAnimation'

function TermsConditions() {
    const sections = [
        {
            title: '1. Who These Terms Apply To',
            body: (
                <>
                    These Terms and Conditions govern your use of the TechDigit Solutions website located at{' '}
                    <strong>techdigitsolutions.com</strong> and any services you engage us to provide. By accessing this website
                    or submitting a contact form, you agree to these terms. If you do not agree, please do not use this website.
                </>
            ),
        },
        {
            title: '2. The Services We Provide',
            body: (
                <>
                    TechDigit Solutions provides medical billing and revenue cycle management, cybersecurity services, call
                    center and customer support outsourcing, and professional content writing services, including ebooks and
                    whitepapers.
                    <br />
                    <br />
                    Specific terms governing any service engagement, including scope, deliverables, timelines, payment terms,
                    and confidentiality obligations, are set out in a separate written agreement signed before work begins.
                    These Terms and Conditions apply to the use of the website and to general interactions. They do not
                    replace or supersede any signed service agreement.
                </>
            ),
        },
        {
            title: '3. No Professional Advice Through This Website',
            body: (
                <>
                    Nothing on this website constitutes legal, medical, financial, or compliance advice. Content published on
                    techdigitsolutions.com is provided for general informational purposes only. If you require advice specific
                    to your legal, medical, financial, or regulatory situation, please consult a qualified professional. TechDigit
                    Solutions accepts no liability for decisions made based on information published on this website.
                </>
            ),
        },
        {
            title: '4. Intellectual Property',
            body: (
                <>
                    All content on this website, including text, design, structure, graphics, and copy, is the property of TechDigit
                    Solutions and is protected by applicable intellectual property laws. You may not copy, reproduce, distribute,
                    or use any content from this website for commercial purposes without our prior written permission. Linking to our
                    website is permitted, provided it is done in a fair, legal, and non-damaging manner that does not damage our
                    reputation.
                </>
            ),
        },
        {
            title: '5. Limitation of Liability',
            body: (
                <>
                    TechDigit Solutions makes reasonable efforts to ensure the information on this website is accurate and current.
                    However, we make no warranties, express or implied, regarding the completeness, accuracy, or fitness for purpose
                    of any content published here. To the fullest extent permitted by applicable law, TechDigit Solutions shall not be liable
                    for any indirect, incidental, or consequential damages arising from your use of this website or reliance on its content.
                </>
            ),
        },
        {
            title: '6. Third Party Links',
            body: (
                <>
                    This website may contain links to third-party websites. These links are provided for convenience only. TechDigit
                    Solutions does not endorse, control, or accept responsibility for the content or privacy practices of any third-party
                    website. Visiting linked websites is at your own risk.
                </>
            ),
        },
        {
            title: '7. Privacy',
            body: (
                <>
                    Your use of this website is also governed by our Privacy Policy, which is incorporated into these Terms and
                    Conditions by reference. You can read our full Privacy Policy at{' '}
                    <Link to="/privacy-policy">techdigitsolutions.com/privacy-policy</Link>.
                </>
            ),
        },
        {
            title: '8. Changes to These Terms',
            body: (
                <>
                    We reserve the right to update these Terms and Conditions at any time. Changes take effect immediately upon posting
                    to this page. The date at the top of this page reflects when the terms were last updated. Continued use of this website
                    after any changes constitutes your acceptance of the updated terms.
                </>
            ),
        },
        {
            title: '9. Governing Law',
            body: (
                <>
                    These Terms and Conditions are governed by the laws of the United States and the state in which TechDigit Solutions is
                    registered, without regard to conflict-of-laws principles. Any disputes arising under these terms shall be resolved in the
                    courts of that jurisdiction.
                </>
            ),
        },
        {
            title: '10. Contact Us',
            body: (
                <>
                    If you have any questions about these Terms and Conditions, please contact us directly.
                    <br />
                    <strong>info@techdigitsolutions.com</strong>
                </>
            ),
        },
    ]

    return (
        <div className="index-six legal-page terms-page">
            <style>
                {`
                .terms-page .rts-section-gap {
                    padding: 120px 60px!important;
                }
                `}
            </style>
            <HeaderSix />
            <main>
                <ScrollAnimation direction="fade" delay={0.03} duration={0.38}>
                    <div className="about-page-breadcrumb">
                        <div className="container">
                            <h1 className="about-page-breadcrumb__title">Terms and Conditions</h1>
                        </div>
                    </div>
                </ScrollAnimation>

                <ScrollAnimation direction="up" delay={0.06} duration={0.48}>
                    <section className="td-section rts-section-gap">
                        <div className="container-fluid">
                            <p className="disc mt-3">
                                <strong>Last Updated:</strong> March 2025
                            </p>

                            <div className="td-legal-page__panel">
                                {sections.map((s) => (
                                    <div key={s.title} className="td-legal-page__section">
                                        <h3 className="td-legal-page__section-title">{s.title}</h3>
                                        <p className="td-legal-page__section-body">{s.body}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                </ScrollAnimation>
            </main>
            <FooterSix />
        </div>
    )
}

export default TermsConditions

